/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RichiesteCausaliCdlResponseDTO
 */
export interface RichiesteCausaliCdlResponseDTO {
    /**
     * 
     * @type {number}
     * @memberof RichiesteCausaliCdlResponseDTO
     */
    id?: number;
    /**
     * 
     * @type {Date}
     * @memberof RichiesteCausaliCdlResponseDTO
     */
    dataRichiesta?: Date;
    /**
     * 
     * @type {string}
     * @memberof RichiesteCausaliCdlResponseDTO
     */
    idCausaleRichiesta?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RichiesteCausaliCdlResponseDTO
     */
    causale?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof RichiesteCausaliCdlResponseDTO
     */
    daData?: Date;
    /**
     * 
     * @type {Date}
     * @memberof RichiesteCausaliCdlResponseDTO
     */
    aData?: Date;
    /**
     * 
     * @type {number}
     * @memberof RichiesteCausaliCdlResponseDTO
     */
    ore?: number | null;
    /**
     * 
     * @type {string}
     * @memberof RichiesteCausaliCdlResponseDTO
     */
    approvazione?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RichiesteCausaliCdlResponseDTO
     */
    approvatore?: string | null;
    /**
     * 
     * @type {number}
     * @memberof RichiesteCausaliCdlResponseDTO
     */
    idRichiedente?: number;
    /**
     * 
     * @type {string}
     * @memberof RichiesteCausaliCdlResponseDTO
     */
    richiedente?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RichiesteCausaliCdlResponseDTO
     */
    note?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RichiesteCausaliCdlResponseDTO
     */
    isDeletable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RichiesteCausaliCdlResponseDTO
     */
    primoApprovatore?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RichiesteCausaliCdlResponseDTO
     */
    secondoApprovatore?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof RichiesteCausaliCdlResponseDTO
     */
    approvatoIl?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof RichiesteCausaliCdlResponseDTO
     */
    noteApprovatore?: string | null;
}

/**
 * Check if a given object implements the RichiesteCausaliCdlResponseDTO interface.
 */
export function instanceOfRichiesteCausaliCdlResponseDTO(value: object): value is RichiesteCausaliCdlResponseDTO {
    return true;
}

export function RichiesteCausaliCdlResponseDTOFromJSON(json: any): RichiesteCausaliCdlResponseDTO {
    return RichiesteCausaliCdlResponseDTOFromJSONTyped(json, false);
}

export function RichiesteCausaliCdlResponseDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): RichiesteCausaliCdlResponseDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'dataRichiesta': json['dataRichiesta'] == null ? undefined : (new Date(json['dataRichiesta'])),
        'idCausaleRichiesta': json['idCausaleRichiesta'] == null ? undefined : json['idCausaleRichiesta'],
        'causale': json['causale'] == null ? undefined : json['causale'],
        'daData': json['daData'] == null ? undefined : (new Date(json['daData'])),
        'aData': json['aData'] == null ? undefined : (new Date(json['aData'])),
        'ore': json['ore'] == null ? undefined : json['ore'],
        'approvazione': json['approvazione'] == null ? undefined : json['approvazione'],
        'approvatore': json['approvatore'] == null ? undefined : json['approvatore'],
        'idRichiedente': json['idRichiedente'] == null ? undefined : json['idRichiedente'],
        'richiedente': json['richiedente'] == null ? undefined : json['richiedente'],
        'note': json['note'] == null ? undefined : json['note'],
        'isDeletable': json['isDeletable'] == null ? undefined : json['isDeletable'],
        'primoApprovatore': json['primoApprovatore'] == null ? undefined : json['primoApprovatore'],
        'secondoApprovatore': json['secondoApprovatore'] == null ? undefined : json['secondoApprovatore'],
        'approvatoIl': json['approvatoIl'] == null ? undefined : (new Date(json['approvatoIl'])),
        'noteApprovatore': json['noteApprovatore'] == null ? undefined : json['noteApprovatore'],
    };
}

export function RichiesteCausaliCdlResponseDTOToJSON(json: any): RichiesteCausaliCdlResponseDTO {
    return RichiesteCausaliCdlResponseDTOToJSONTyped(json, false);
}

export function RichiesteCausaliCdlResponseDTOToJSONTyped(value?: RichiesteCausaliCdlResponseDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'dataRichiesta': value['dataRichiesta'] == null ? undefined : ((value['dataRichiesta']).toISOString()),
        'idCausaleRichiesta': value['idCausaleRichiesta'],
        'causale': value['causale'],
        'daData': value['daData'] == null ? undefined : ((value['daData']).toISOString()),
        'aData': value['aData'] == null ? undefined : ((value['aData']).toISOString()),
        'ore': value['ore'],
        'approvazione': value['approvazione'],
        'approvatore': value['approvatore'],
        'idRichiedente': value['idRichiedente'],
        'richiedente': value['richiedente'],
        'note': value['note'],
        'isDeletable': value['isDeletable'],
        'primoApprovatore': value['primoApprovatore'],
        'secondoApprovatore': value['secondoApprovatore'],
        'approvatoIl': value['approvatoIl'] == null ? undefined : ((value['approvatoIl'] as any).toISOString()),
        'noteApprovatore': value['noteApprovatore'],
    };
}

